(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2676],{

/***/ 16027:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/category/[slug]",
      function () {
        return __webpack_require__(47354);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var components_templates_SinglePage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16318);

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (components_templates_SinglePage__WEBPACK_IMPORTED_MODULE_0__/* .SinglePageTemplate */ .$);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1176,2569,6318,9774,2888,179], function() { return __webpack_exec__(16027); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);